/**
 * 文件上传管理API
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'
const serviceModule = context.sunflower

export default {

  /**
   * 上传图片
   *
   * @param params 参数
   * @param fileList 文件列表
   */
  fileUpload: (params, fileList) => {
    return request.uploadWithJson(serviceModule + "/file/image/uploadImage", {formData: params}, {fileList});
  },

}
